import { selectAnatomy } from "@ark-ui/react/select";
import { defineSlotRecipe } from "@chakra-ui/react";

export default defineSlotRecipe({
  className: "chakra-select",
  slots: selectAnatomy.extendWith("indicatorGroup").keys(),
  variants: {
    variant: {
      workspace: {
        trigger: {
          background: "white/10",
          borderRadius: "l1",
          borderWidth: "0",
          boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.08)" as any,
          color: "white",
          fontFamily: "inter",
          fontSize: "sm",
          fontWeight: "medium",
          height: "10",
          minHeight: "10",
          _hover: {
            background: "white/14",
          },
          _focus: {
            boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.15)" as any,
          },
        },
      },
    },
  },
});
